/* tslint:disable */
/* eslint-disable */
/**
 * MCP Manager API
 * API for managing Model Context Protocol (MCP) connections
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { MCPServerWithToolsFromJSON, PatchServerPayloadToJSON, ServerFromTemplatePayloadToJSON, ServerPayloadToJSON, ServerResponseFromJSON, ServersGlobalIdChannelsChannelIdTogglePatchRequestToJSON, ServersGlobalIdChannelsPostRequestToJSON, } from '../models/index';
/**
 *
 */
export class ServersApi extends runtime.BaseAPI {
    /**
     * Delete servers by global_ids
     */
    serversDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['globalIds'] == null) {
                throw new runtime.RequiredError('globalIds', 'Required parameter "globalIds" was null or undefined when calling serversDelete().');
            }
            const queryParameters = {};
            if (requestParameters['globalIds'] != null) {
                queryParameters['global_ids'] = requestParameters['globalIds'].join(runtime.COLLECTION_FORMATS["csv"]);
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/servers`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete servers by global_ids
     */
    serversDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.serversDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Create a server from a template
     */
    serversFromTemplateTemplateIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['templateId'] == null) {
                throw new runtime.RequiredError('templateId', 'Required parameter "templateId" was null or undefined when calling serversFromTemplateTemplateIdPost().');
            }
            if (requestParameters['serverFromTemplatePayload'] == null) {
                throw new runtime.RequiredError('serverFromTemplatePayload', 'Required parameter "serverFromTemplatePayload" was null or undefined when calling serversFromTemplateTemplateIdPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/servers/from-template/{template_id}`.replace(`{${"template_id"}}`, encodeURIComponent(String(requestParameters['templateId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ServerFromTemplatePayloadToJSON(requestParameters['serverFromTemplatePayload']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create a server from a template
     */
    serversFromTemplateTemplateIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.serversFromTemplateTemplateIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List all servers
     */
    serversGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['scopeType'] != null) {
                queryParameters['scope_type'] = requestParameters['scopeType'];
            }
            if (requestParameters['scopeId'] != null) {
                queryParameters['scope_id'] = requestParameters['scopeId'];
            }
            if (requestParameters['channelId'] != null) {
                queryParameters['channel_id'] = requestParameters['channelId'];
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/servers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ServerResponseFromJSON));
        });
    }
    /**
     * List all servers
     */
    serversGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.serversGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Remove a channel from a server
     */
    serversGlobalIdChannelsChannelIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['globalId'] == null) {
                throw new runtime.RequiredError('globalId', 'Required parameter "globalId" was null or undefined when calling serversGlobalIdChannelsChannelIdDelete().');
            }
            if (requestParameters['channelId'] == null) {
                throw new runtime.RequiredError('channelId', 'Required parameter "channelId" was null or undefined when calling serversGlobalIdChannelsChannelIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/servers/{global_id}/channels/{channel_id}`.replace(`{${"global_id"}}`, encodeURIComponent(String(requestParameters['globalId']))).replace(`{${"channel_id"}}`, encodeURIComponent(String(requestParameters['channelId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Remove a channel from a server
     */
    serversGlobalIdChannelsChannelIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.serversGlobalIdChannelsChannelIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Toggle channel enabled status
     */
    serversGlobalIdChannelsChannelIdTogglePatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['globalId'] == null) {
                throw new runtime.RequiredError('globalId', 'Required parameter "globalId" was null or undefined when calling serversGlobalIdChannelsChannelIdTogglePatch().');
            }
            if (requestParameters['channelId'] == null) {
                throw new runtime.RequiredError('channelId', 'Required parameter "channelId" was null or undefined when calling serversGlobalIdChannelsChannelIdTogglePatch().');
            }
            if (requestParameters['serversGlobalIdChannelsChannelIdTogglePatchRequest'] == null) {
                throw new runtime.RequiredError('serversGlobalIdChannelsChannelIdTogglePatchRequest', 'Required parameter "serversGlobalIdChannelsChannelIdTogglePatchRequest" was null or undefined when calling serversGlobalIdChannelsChannelIdTogglePatch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/servers/{global_id}/channels/{channel_id}/toggle`.replace(`{${"global_id"}}`, encodeURIComponent(String(requestParameters['globalId']))).replace(`{${"channel_id"}}`, encodeURIComponent(String(requestParameters['channelId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: ServersGlobalIdChannelsChannelIdTogglePatchRequestToJSON(requestParameters['serversGlobalIdChannelsChannelIdTogglePatchRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Toggle channel enabled status
     */
    serversGlobalIdChannelsChannelIdTogglePatch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.serversGlobalIdChannelsChannelIdTogglePatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Add a channel to a server
     */
    serversGlobalIdChannelsPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['globalId'] == null) {
                throw new runtime.RequiredError('globalId', 'Required parameter "globalId" was null or undefined when calling serversGlobalIdChannelsPost().');
            }
            if (requestParameters['serversGlobalIdChannelsPostRequest'] == null) {
                throw new runtime.RequiredError('serversGlobalIdChannelsPostRequest', 'Required parameter "serversGlobalIdChannelsPostRequest" was null or undefined when calling serversGlobalIdChannelsPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/servers/{global_id}/channels`.replace(`{${"global_id"}}`, encodeURIComponent(String(requestParameters['globalId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ServersGlobalIdChannelsPostRequestToJSON(requestParameters['serversGlobalIdChannelsPostRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Add a channel to a server
     */
    serversGlobalIdChannelsPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.serversGlobalIdChannelsPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update specific server fields
     */
    serversPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['globalId'] == null) {
                throw new runtime.RequiredError('globalId', 'Required parameter "globalId" was null or undefined when calling serversPatch().');
            }
            if (requestParameters['patchServerPayload'] == null) {
                throw new runtime.RequiredError('patchServerPayload', 'Required parameter "patchServerPayload" was null or undefined when calling serversPatch().');
            }
            const queryParameters = {};
            if (requestParameters['globalId'] != null) {
                queryParameters['global_id'] = requestParameters['globalId'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/servers`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: PatchServerPayloadToJSON(requestParameters['patchServerPayload']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Update specific server fields
     */
    serversPatch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.serversPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a new server
     */
    serversPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['serverPayload'] == null) {
                throw new runtime.RequiredError('serverPayload', 'Required parameter "serverPayload" was null or undefined when calling serversPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/servers`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ServerPayloadToJSON(requestParameters['serverPayload']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create a new server
     */
    serversPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.serversPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Test MCP server connection and return available tools
     */
    serversTestConnectionPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['serverPayload'] == null) {
                throw new runtime.RequiredError('serverPayload', 'Required parameter "serverPayload" was null or undefined when calling serversTestConnectionPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/servers/test-connection`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ServerPayloadToJSON(requestParameters['serverPayload']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MCPServerWithToolsFromJSON(jsonValue));
        });
    }
    /**
     * Test MCP server connection and return available tools
     */
    serversTestConnectionPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.serversTestConnectionPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const ServersGetScopeTypeEnum = {
    Organization: 'organization',
    Workspace: 'workspace',
    Portal: 'portal',
    User: 'user'
};
